import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	VLAN_POOL_PROFILE_FILTER_EVENT,
	VLAN_POOL_PROFILE_FOCUS_EVENT,
	VLAN_POOL_PROFILE_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.vlan_pools']);

/**
 * Open the VLAN Pool accordion on the Templates page.
 *
 * Event-based rather than a DOM click, the way the SSID Template and
 * SSID Schedule sections on this page already are: the page owns which
 * accordion is expanded, and it scrolls the panel into view before it
 * reports back. Retried until the page mounts, so arriving here from
 * another route works as well as already standing on it.
 *
 * @return {Promise<void>} completion acknowledgement
 */
export function openVlanPoolProfileSection() {
	return openResourceSection(
		VLAN_POOL_PROFILE_SECTION_EVENT,
		'profile.vlan_pools',
		SECTIONS,
	);
}

/**
 * Filter the VLAN Pool table to a search term.
 *
 * The table asks Canvas for the matching page rather than filtering the
 * rows it happens to be showing, so a profile on any page is findable.
 *
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applyVlanPoolProfileFilter(query) {
	return dispatchAcknowledgedEvent(VLAN_POOL_PROFILE_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'vlan_pooling',
	});
}

/**
 * Point at one VLAN Pool's row in the table.
 * @param {string} entityId profile identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusVlanPoolProfile(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_vlan_pool_focus'));
	return dispatchAcknowledgedEvent(VLAN_POOL_PROFILE_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'vlan_pooling',
	});
}
